import React, { Component } from 'react';
import _ from 'lodash';
import {
    getErroredPayouts as fetchErroredPayouts,
    fetchUrl
} from './erroredPayoutsActions';
import {
    getErroredPayouts,
    getCount,
    getPages,
    getErroredPayoutsErrorMessage,
    getIsErroredPayoutsLoading
} from './erroredPayoutsEntity';
import ErroredPayoutsListItem from './ErroredPayoutsListItem/ErroredPayoutsListItem';
import Table from '../../Table/Table';
import { payoutProviderMapper, dataTransform } from '@nexio/emvio-util-app';
import PropTypes from 'prop-types';
import { getSelectedPayoutAccountIdsString } from '../../PayoutAccountSelector/payoutAccountSelectorViewState';
import { getPayoutAccountsMapper } from '../../PayoutAccounts/payoutAccountEntity';
import { getColumnsByUniqueTableName } from '../../Table/tableEntity';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import './ErroredPayouts.scss';
import { getIsUserAnAdmin } from '../../UserData/userDataEntity';
import { prettifyMoney } from '@nexio/emvio-util-app';
import RequestBodyCell from '../../Table/Cells/RequestBodyCell/RequestBodyCell';
import FilterWithMapper from '../../Table/Filters/FilterWithMapper/FilterWithMapper';

export class ErroredPayouts extends Component {
    dateKey = 'updatedAt';

    static propTypes = {
        selectedPayoutAccountIds: PropTypes.string,
        columns: PropTypes.array,
        payoutAccountMap: PropTypes.any,
        timezone: PropTypes.string,
        isAdmin: PropTypes.bool,
        isForPayoutRecipientTable: PropTypes.bool,
        recipientId: PropTypes.number,
        uniqueTableName: PropTypes.string,
        value: PropTypes.any
    };

    constructor(props) {
        super(props);

        this.state = {};

        this.defaultColumnsAndProps = [
            {
                accessor: 'errorReason',
                Cell: (props) => (<RequestBodyCell body={props.value}/>),
                className: ['cursor-pointer', 'left-justify'],
                filterable: false,
                label: 'Error',
                minWidth: 250,
                show: true,
                sortable: false
            },
            {
                accessor: 'amount',
                transformData: (data) => {
                    const request = JSON.parse(_.get(data, 'original.request'));
                    const amount = _.get(request, 'amount') || '';
                    const currencyCode = _.get(request, 'currency');

                    return `${prettifyMoney(amount, currencyCode)}`;
                },
                className: ['right-justify', 'cursor-pointer'],
                label: 'Amount',
                minWidth: 120,
                show: true,
                sortable: false,
                filterable: false
            },
            {
                accessor: 'batchRef',
                label: 'Batch Ref',
                minWidth: 150,
                show: true,
                sortable: false
            },
            {
                accessor: 'country',
                transformData: (data) => {
                    const request = JSON.parse(_.get(data, 'original.request'));

                    return _.get(request, 'country') || '';
                },
                label: 'Country',
                minWidth: 110,
                show: true,
                sortable: true,
                filterable: false
            },
            {
                accessor: 'currency',
                transformData: (data) => {
                    const request = JSON.parse(_.get(data, 'original.request'));

                    return _.get(request, 'currency') || '';
                },
                label: 'Currency',
                minWidth: 75,
                show: true,
                sortable: false,
                filterable: false
            },
            {
                accessor: 'email',
                transformData: (data) => {
                    const request = JSON.parse(_.get(data, 'original.request'));

                    return _.get(request, 'recipient.email') || '';
                },
                label: 'Email',
                minWidth: 175,
                show: true,
                sortable: false,
                filterable: false
            },
            {
                accessor: 'firstName',
                transformData: (data) => {
                    const request = JSON.parse(_.get(data, 'original.request'));

                    return _.get(request, 'recipient.firstName') || '';
                },
                label: 'First Name',
                minWidth: 120,
                show: true,
                sortable: false,
                filterable: false
            },
            {
                accessor: 'lastName',
                transformData: (data) => {
                    const request = JSON.parse(_.get(data, 'original.request'));

                    return _.get(request, 'recipient.lastName') || '';
                },
                label: 'Last Name',
                minWidth: 120,
                show: true,
                sortable: false,
                filterable: false
            },
            {
                accessor: 'payoutAccountId',
                transformData: (data) => `${data.original.payoutAccountId} - ${this.props.payoutAccountMap[data.original.payoutAccountId]}`,
                filterable: true,
                Filter: ({ filter, onChange }) => (
                    <FilterWithMapper filter={filter}
                        mapper={this.getPayoutAccountsDropDown()}
                        onChange={onChange}
                    />
                ),
                label: 'Payout Account',
                minWidth: 250,
                show: true,
                sortable: true
            },
            {
                accessor: 'phoneNumber',
                transformData: (data) => {
                    const request = JSON.parse(_.get(data, 'original.request'));

                    return _.get(request, 'recipient.phoneNumber') || '';
                },
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Phone Number',
                minWidth: 150,
                show: false,
                sortable: false
            },
            {
                accessor: 'providerId',
                filterable: false,
                transformData: (data) => {
                    const request = JSON.parse(_.get(data, 'original.request'));

                    return _.get(request, 'recipient.providerId') || '';
                },
                label: 'Provider ID',
                minWidth: 90,
                show: true,
                sortable: false
            },
            {
                accessor: 'recipientId',
                filterable: false,
                transformData: (data) => {
                    const request = JSON.parse(_.get(data, 'original.request'));

                    return _.get(request, 'recipientId') || '';
                },
                label: 'Recipient ID',
                minWidth: 90,
                show: true,
                sortable: false
            },
            {
                accessor: 'recipientRef',
                filterable: false,
                transformData: (data) => {
                    const request = JSON.parse(_.get(data, 'original.request'));

                    return _.get(request, 'recipient.recipientRef') || '';
                },
                label: 'Recipient Reference',
                minWidth: 150,
                show: true,
                sortable: false
            },
            {
                accessor: 'providerType',
                label: 'Payout Provider Name',
                transformData: dataTransform.payoutProviderMapper,
                Filter: ({ filter, onChange }) => (
                    <FilterWithMapper
                        filter={filter}
                        mapper={payoutProviderMapper}
                        onChange={onChange}
                    />
                ),
                filterable: true,
                minWidth: 160,
                show: true,
                sortable: false
            },
            {
                accessor: 'request',
                Cell: (props) => (<RequestBodyCell body={JSON.parse(props.value)}/>),
                className: ['cursor-pointer'],
                label: 'Request Body',
                minWidth: 250,
                show: true,
                sortable: false,
                filterable: false
            }
        ];
    }

    getTableState = (tableState) => {
        this.setState({
            ...tableState
        });
    };

    getPayoutAccountsDropDown = () => {
        const result = {};
        _.forEach(this.props.payoutAccountMap, (value, key) => {
            result[key] = `${key} - ${value}`;
        });

        return result;
    };

    render() {
        return (
            <div className="emvio-errored-payouts">
                <Table
                    fetchUrl={fetchUrl}
                    className="emvio-errored-payouts-table"
                    dateKey={this.dateKey}
                    defaultColumnsAndProps={this.defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: this.dateKey
                    }]}
                    fetchData={(filters, page, pageSize, sorters, merchantIds, columns) => fetchErroredPayouts(filters, page, pageSize, sorters, this.props.selectedPayoutAccountIds, columns)}
                    countSelector={getCount}
                    dataSelector={getErroredPayouts}
                    errorMessageSelector={getErroredPayoutsErrorMessage}
                    isDataLoadingSelector={getIsErroredPayoutsLoading}
                    pagesSelector={getPages}
                    itemKey="id"
                    hasNoCount={true}
                    ListItemComponent={ErroredPayoutsListItem}
                    noDataText="No Bad Payouts Found"
                    shouldUseGlobalDate
                    uniqueTableName={this.props.uniqueTableName || 'erroredPayouts'}
                    getTableState={this.getTableState}
                    filterable={true}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedPayoutAccountIds: getSelectedPayoutAccountIdsString(state),
        columns: getColumnsByUniqueTableName(state, 'erroredPayouts'),
        payoutAccountMap: getPayoutAccountsMapper(state),
        isAdmin: getIsUserAnAdmin(state)
    };
}

export default withRouter(connect(mapStateToProps)(ErroredPayouts));
